import { IDataSet } from '../Track';
import { TSocialActionType } from './Transaction';

export class ResourceDataSet implements IDataSet {
    /**
     * The number of fan boosters recieved by the user
     */
    tChangerReceived: number = 0;
    /**
     * The number of fan boosters used in this transaction
     */
    tChangerUsed: number = 0;
    /**
     * The number of coins spent on fan boosters this level
     */
    tChangerCoins: number = 0;
    /**
     * The number of slingshot boosters recieved by the user
     */
    tRemoveOneReceived: number = 0;
    /**
     * The number of slingshot boosters used in this transaction
     */
    tRemoveOneUsed: number = 0;
    /**
     * The number of coins spent on slingshot boosters this level
     */
    tRemoveOneCoins: number = 0;
    /**
     * The number of Canister boosters recieved by the user
     */
    tMassRemoveReceived: number = 0;
    /**
     * The number of Canister boosters used in this transaction
     */
    tMassRemoveUsed: number = 0;
    /**
     * The number of coins spent on canister boosters this level
     */
    tMassRemoveCoins: number = 0;

    /**
     * The number of free entry boosters recieved by the user
     */
    tFreeEntryReceived: number = 0;
    /**
     * The number of free entry boosters used in this transaction
     */
    tFreeEntryUsed: number = 0;
    /**
     * The number of plus 5 boosters recieved by the user
     */
    tPlus5Received: number = 0;
    /**
     * The number of plus 5 boosters used in this transaction
     */
    tPlus5Used: number = 0;

    /**
     * The number of Joker boosters recieved by the user
     */
    tJokerReceived: number = 0;
    /**
     * The number of Joker boosters used in this transaction
     */
    tJokerUsed: number = 0;
    /**
     * The number of coins spent on jokers this level
     */
    tJokerCoins: number = 0;
    /**
     * The number of undo boosters recieved by the user
     */
    tUndoReceived: number = 0;
    /**
     * The number of undo boosters used in this transaction
     */
    tUndoUsed: number = 0;
    /**
     * The number of coins spent on undos this level
     */
    tUndoCoins: number = 0;
    /**
     * The number of coins received by the user - Note: this is ONLY for receiving coins and should be ONLY positive, in that case
     */
    tCoinsReceived: number = 0;
    /**
     * The number of coins used
     */
    tCoinsUsed: number = 0;
    /** */
    tExtraCardsReceived: number = 0;
    /** */
    tExtraCardsCoins: number = 0;

    /** The number of pre booster remove 3 cards received by the user */
    tRemoveCardsBoostersReceived: number = 0;
    /** The number of pre booster remove 3 cards used in this transaction */
    tRemoveCardsBoostersUsed: number = 0;
    /** The number of coins spent on pre booster remove 3 cards this level */
    tRemoveCardsBoostersCoins: number = 0;

    /** The number of pre booster extra wild cards received by the user */
    tExtraWildcardsBoostersReceived: number = 0;
    /** The number of pre booster extra wild cards used in this transaction */
    tExtraWildcardsBoostersUsed: number = 0;
    /** The number of coins spent on pre booster extra wild cards this level */
    tExtraWildcardsBoostersCoins: number = 0;

    /** The number of pre booster canister card received by the user */
    tCanisterCardBoostersReceived: number = 0;
    /** The number of pre booster canister card used in this transaction */
    tCanisterCardBoostersUsed: number = 0;
    /** The number of coins spent on pre booster canister card this level */
    tCanisterCardBoostersCoins: number = 0;

    /** */
    tHelperCards: number = 0;
    /**
     * If this resource event was a part of the star chest minigame, then which star chest type.
     * NOTE: this should be an integer. 1 - wooden chest. 2 - bronze 3 - silver 4 - gold 5 - diamond
     */
    tStarChestType: number | undefined = undefined;

    /**
     * Describes the social action done (for example: INVITE, SEND_LIVES)
     */
    socialActionType: TSocialActionType = undefined;
    /**
     * Describes whether the event resulted from sending something to another user.
     * Importantly - this is boolean, but it's important to send 0 or 1 so that we can aggregate
     */
    socialSend: number = 0;
    /**
     * Describes whether the event resulted from receiving something from another user.
     * Importantly - this is boolean, but it's important to send 0 or 1 so that we can aggregate
     */
    socialRecieve: number = 0;

    /**
     * Describes the quest that was just completed
     */
    tQuestName: string = undefined;
    tQuestID: string = undefined;
    tQuestTier: number = 0;

    /**
     * Describes a resource event that added progress to a quest
     */
    tQuest1ProgressGained: number = 0;
    tQuest2ProgressGained: number = 0;
    tQuest3ProgressGained: number = 0;
}
